import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import './index.scss'
import MainHeader from '../components/headers/main-header'
import MenuComponent from '../components/burger-menu'
import logo from '../assets/images/logo.png';
console.log('Logo obj', logo)
export default class TemplateWrapper extends React.Component {
  constructor() {
    super()
  }
  componentWillMount() {
    typeof window !== 'undefined' && window.location.pathname === '/' && (this.showMenu = true)
  }
  render() {
    return (<div id="outer-container">
      {this.showMenu && (<MenuComponent class="menu-mobile" />)}
      <Helmet
        title="Pzaf 2018 - Postgraduate Zooarchaeology Forum"
        meta={[
          { name: 'description', content: 'PZAF is an annual conference organised by and for postgraduate students and early-career professionals in the field of zooarchaeology.' },
          { name: 'keywords', content: 'Pzaf, Zooarchaeology' },
          { name: 'thumbnail', content: logo },
          { property: 'og:title', content: 'Pzaf 2018 - Postgraduate Zooarchaeology Forum' },
          { property: 'og:description', content: 'PZAF is an annual conference organised by and for postgraduate students and early-career professionals in the field of zooarchaeology.' },
          { property: 'og:image', content: logo },
          { name: 'twitter:title', content: 'Pzaf 2018 - Postgraduate Zooarchaeology Forum' },
          { name: 'twitter:description', content: 'PZAF is an annual conference organised by and for postgraduate students and early-career professionals in the field of zooarchaeology.' },
          { name: 'twitter:card', content: 'summary'},
          { name: 'twitter:image', content: logo},
          { name: 'google-site-verification', content: 'AMZ8_m0bX3hWRe4YxM05RzqRSo1cZ77c7B998NzU4X4'}
        ]}
      />
      <MainHeader />
      <main id="page-wrap">
        {this.props.children()}
      </main>
    </div>)
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/layouts/index.js